import type { ComponentProps } from 'react'
import { ListChecks } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { ClientBehaviorsPage } from './admin/ClientBehaviorsPage.js'

/** What the behaviors module contributes to the shells: the admin's behaviors manager for any client. */
export const behaviorsWebModule: WebModule<ComponentProps<typeof ClientBehaviorsPage>['api']> = {
  name: 'behaviors',
  adminPages: [{ path: '/admin/behaviors', label: 'Behaviors', title: 'Behaviors', icon: ListChecks, group: 'scoring', page: ({ api }) => <ClientBehaviorsPage api={api} /> }],
}
